<script lang="ts">
    import { onMount } from 'svelte/internal'
    import DateSelect from '../_common/date-select.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import { GridClass } from '../_common/z/zgrid'
    import { buildReportGrid } from './_shared/build-report-grid'
    import { inferChartConfig, REPORT_VIEW_MODE_OPTIONS } from './_shared/report-chart-defaults'
    import type { ReportViewMode } from './_shared/report-chart-defaults'
    import ReportChartViewer from './_shared/report-chart-viewer.svelte'
    import type { ReportCatalogItem, ReportResponse } from '../../modules/reportsApi/catalog/report-catalog'

    export let report: ReportCatalogItem

    let show = false
    let viewMode: ReportViewMode = window.store.reportViewMode
    let values: Record<string, any> = {}
    let response: ReportResponse = null
    let grid: GridClass = null
    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.currentMonth()

    $: chartConfig = response ? inferChartConfig(response) : null

    function viewModeChanged() {
        window.store.reportViewMode = viewMode
    }

    // datas são tratadas à parte, via DateSelect — os demais tipos de parâmetro continuam genéricos. Relatórios
    // sem parâmetro de data (ex: saldos/crédito, que são uma fotografia do momento atual) não mostram o DateSelect.
    // 'datetime' recebe o mesmo tratamento que 'date' aqui — é só a granularidade que o backend espera (com
    // hora), a UI de seleção continua a mesma (ver report-catalog.interface.ts no zandu-api).
    const isDateParam = (p: { type: string }) => p.type === 'date' || p.type === 'datetime'
    const hasDateParams = report.params.some(isDateParam)
    const otherParams = report.params.filter((p) => !isDateParam(p))

    function defaultValue(type: string) {
        if (type === 'boolean') return false
        return ''
    }

    onMount(() => {
        values = hasDateParams ? { from: dateSelect.from, to: dateSelect.to } : {}
        for (const param of otherParams) values[param.key] = defaultValue(param.type)
        run()
    })

    async function run() {
        if (show) return
        show = true
        try {
            response = await window.api.reports.catalog.run(report.endpoint, values)
            window.api.users.statistics.tick('report.run')
            console.log('report', response)
            grid = buildReportGrid(response)
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function dateChanged(event) {
        dateSelect = event.detail
        values = { ...values, from: dateSelect.from, to: dateSelect.to }
        run()
    }

    function paramChanged() {
        run()
    }
</script>

<div class="relat-body">
    <Zframe title={response?.title || report.label} headline={report.description}>
        {#if hasDateParams || otherParams.length > 0 || chartConfig}
            <Zact class="h-print mb-3">
                {#if hasDateParams}
                    <DateSelect on:change={dateChanged} startFrom={dateSelect.from} startTo={dateSelect.to} />
                {/if}
                {#each otherParams as param}
                    {#if param.type === 'boolean'}
                        <Zinput skin="soft" size={0} type="toggle" label={param.label} bind:value={values[param.key]} on:change={paramChanged} />
                    {:else if param.type === 'number'}
                        <Zinput skin="soft" size={0} type="number" label={param.label} bind:value={values[param.key]} on:change={paramChanged} />
                    {:else}
                        <Zinput skin="soft" size={0} type="text" label={param.label} bind:value={values[param.key]} on:change={paramChanged} />
                    {/if}
                {/each}
                {#if chartConfig}
                    <div class="spacer" />
                    <Zinput size={0} type="select" label="Exibição" options={REPORT_VIEW_MODE_OPTIONS} bind:value={viewMode} on:change={viewModeChanged} />
                {/if}
            </Zact>
        {/if}
        {#if chartConfig && (viewMode === 'chart' || viewMode === 'report-chart')}
            <div class="mb-3">
                <ReportChartViewer {response} dimensionKey={chartConfig.dimensionKey} valueKey={chartConfig.valueKey} type={chartConfig.type} />
            </div>
        {/if}
        {#if !chartConfig || viewMode === 'report' || viewMode === 'report-chart'}
            <Zgrid {grid} />
        {/if}
    </Zframe>
</div>
<LoadSpinner {show}></LoadSpinner>
